import { View } from '@droplet-tech-code/core-elements/module/ui/View';
import { useCallback } from 'react';

export const useItemSeparatorComponent = () => {
  return useCallback(() => {
    return <View my="1" />;
  }, []);
};
